import { Api } from "../../api/api";

export class RichTextEditorApi extends Api {
    public static destroy(relativeElem: HTMLElement) {
        Api.callApiFn(relativeElem, "s25-ng-rich-text-editor", "ngOnDestroy");
    }
}
